import { safeMutate } from "../../../../../utils/GeneralUtils";
import { eventTracker, getEventDetails } from "../../../../generic/Utils/eventTracker";
import { getMetricsDataFromArray } from "../../../Metrics/utils";

const getChartConfig = function(props = {}) {
  const { metrics, seriesMetricsUids, metricColorMap } = props;
  const seriesMetrics = getMetricsDataFromArray(metrics, seriesMetricsUids);
  const totalValue = seriesMetrics.reduce((accumulator, metric) => accumulator + metric.data.value, 0);

  const getAdditionalEventDetails = function(initialEventDetails){
    const eventDetails = getEventDetails(initialEventDetails);
    const modifiedEventDetails = safeMutate(eventDetails, draftEventDetails => {
      draftEventDetails.payload.source = chrEventConstants.eventLabel.VIEWED_IN_CHART;
    });
    return modifiedEventDetails;
  }

  const seriesData = seriesMetrics.map(metric => {
    return {
      name: metric.name,
      data: [metric.data.value],
      color: metricColorMap[metric.uId],
      url: metric.url,
      cursor: metric.url && "pointer",
      eventDetails: getAdditionalEventDetails(metric.eventDetails),
      events: {
        click: function (_event) {
          const options = this.userOptions;
          if(options.url) {
            window.open(options.url);
            eventTracker(options.eventDetails.eventName, options.eventDetails.payload);
          }
        }
      }
    }
  });

  return {
    chart: {
      height: 40,
      margin: [0, 0, 0, 0]
    },
    xAxis: {
      labels: {
          enabled: false
      },
      visible: false
    },
    yAxis: {
      gridLineWidth: 0,
      max: totalValue,
      endOnTick: false,
      labels: {
        enabled: false
      },
      visible: false,
      title: null,
    },
    exporting: {
      enabled: false
    },
    plotOptions: {
      series: {
        showInLegend: false,
        borderRadius: 8,
        pointWidth: 35,
        borderWidth: 10,
      }
    },
    tooltip: {
      enabled: false
    },
    series: seriesData.reverse()
  }
};

export default getChartConfig;
